<template>
  <div>
    <!-- 替换链接 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="1200px" center>
      <!-- 内容区域 -->
      <div class="dialog-content">

        <!-- 原始链接数据 替换前链接-->
        <div class="title"> {{ routeName == 'pre-saleProblem' ? $t('message.originalLink') :
          $t('message.originalLinkData') }}</div>
        <div class="table">
          <ol>
            <!-- 商品链接 -->
            <li>
              {{ $t('message.ProductLink') }}
            </li>
            <!-- 店铺信息 -->
            <li class="flex05">
              {{ $t('message.storeInformation') }}
            </li>
            <!-- 照片 -->
            <li class="flex05">
              {{ $t('message.pic') }}
            </li>
            <!-- 客户下单属性 -->
            <li>
              {{ $t('message.customerOrderAttributes') }}
            </li>
            <!-- 业务编辑属性 -->
            <li>
              {{ $t('message.businessEditAttributes') }}
            </li>
          </ol>
          <ul>
            <!-- 商品链接 -->
            <li>
              <a :href="replace_goods_info.original.link" target="_blank" class="a-link">{{
                replace_goods_info.original.link }}</a>
            </li>
            <!-- 店铺信息 -->
            <li class="flex05">
              <div class="template">
                <!-- 店铺名 -->
                <div class="row">
                  {{ replace_goods_info.original.shop_name }}
                </div>
                <!-- 平台 -->
                <div class="row">
                  {{ replace_goods_info.original.from_platform }}
                </div>
                <!-- 店铺ID -->
                <div class="row">
                  {{ replace_goods_info.original.shop_id }}
                </div>
              </div>
            </li>
            <!-- 照片 -->
            <li class="flex05">
              <div class="template">
                <!-- 照片 -->
                <div class="img" v-if="replace_goods_info.original.pic">
                  <el-image :src="replace_goods_info.original.pic" fit="fill"
                    style="width: 100px; height: 100px;border-radius: 4px;"
                    :preview-src-list="[replace_goods_info.original.pic]" />
                </div>
              </div>
            </li>
            <!-- 客户下单属性 -->
            <li>
              <div class="template">
                <!-- {{ replace_goods_info.original }} -->
                <!-- 客户下单属性 -->
                <div class="row" v-for="(item, index) in replace_goods_info.original.detail" :key="index">
                  {{ item.key }}: {{ item.value }}
                </div>
              </div>
            </li>
            <!-- 业务编辑属性 -->
            <li>
              <div class="template">
                <!-- 业务编辑属性 -->
                <div class="row" v-for="(item, index) in replace_goods_info.original.detail_y" :key="index">
                  {{ item.key }}: {{ item.value }}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 当前链接数据 -->
        <div class="title" style="margin-top: 20px;">
          {{ routeName == 'pre-saleProblem' ? $t('message.replacedLink') : $t('message.currentLinkData') }}
        </div>
        <div class="table">
          <ol>
            <!-- 商品链接 -->
            <li>
              {{ $t('message.ProductLink') }}
            </li>
            <!-- 店铺信息 -->
            <li class="flex05">
              {{ $t('message.storeInformation') }}
            </li>
            <!-- 照片 -->
            <li class="flex05">
              {{ $t('message.pic') }}
            </li>
            <!-- 客户下单属性 -->
            <li>
              {{ $t('message.customerOrderAttributes') }}
            </li>
            <!-- 业务编辑属性 -->
            <li>
              {{ $t('message.businessEditAttributes') }}
            </li>
          </ol>
          <ul>
            <!-- 商品链接 -->
            <li>
              <a :href="replace_goods_info.new.link" target="_blank" class="a-link">{{ replace_goods_info.new.link
              }}</a>

            </li>
            <!-- 店铺信息 -->
            <li class="flex05">
              <div class="template">
                <!-- 店铺名 -->
                <div class="row">
                  {{ replace_goods_info.new.shop_name }}
                </div>
                <!-- 平台 -->
                <div class="row">
                  {{ replace_goods_info.new.from_platform }}
                </div>
                <!-- 店铺ID -->
                <div class="row">
                  {{ replace_goods_info.new.shop_id }}
                </div>
              </div>
            </li>
            <!-- 照片 -->
            <li class="flex05">
              <div class="template">
                <!-- 照片 -->
                <div class="img" v-if="replace_goods_info.new.pic">
                  <el-image :src="replace_goods_info.new.pic" fit="fill"
                    style="width: 100px; height: 100px;border-radius: 4px;"
                    :preview-src-list="[replace_goods_info.new.pic]" />
                </div>
              </div>

            </li>
            <!-- 客户下单属性 -->
            <li>
              <div class="template">
                <!-- 客户下单属性 -->
                <div class="row" v-for="(item, index) in replace_goods_info.new.detail" :key="index">
                  {{ item.key }}: {{ item.value }}
                </div>
              </div>
            </li>
            <!-- 业务编辑属性 -->
            <li>
              <div class="template">
                <!-- 业务编辑属性 -->
                <div class="row" v-for="(item, index) in replace_goods_info.new.detail_y" :key="index">
                  {{ item.key }}: {{ item.value }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routeName: this.$route.name,
      dialogVisible: false,
      replace_goods_info: {
        new: {
          link: '',
          problem_goods_id: '',
          from_platform: '',
          goods_id: '',
          pic: '',
          shop_id: '',
          shop_name: '',
          detail: [],
          sku_id: '',
          spec_id: '',
          detail_y: [],
          sku_id_y: '',
          spec_id_y: '',
        },
        original: {
          link: '',
          problem_goods_id: '',
          from_platform: '',
          goods_id: '',
          pic: '',
          shop_id: '',
          shop_name: '',
          detail: [],
          sku_id: '',
          spec_id: '',
          detail_y: [],
          sku_id_y: '',
          spec_id_y: '',
        },
      },
    };
  },
  methods: {
    // 提交表单
    submitForm() {
      this.dialogVisible = false
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-content {
  .table {
    li {
      margin-right: 12px;
      cursor: pointer;

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .img {
      position: relative;

    }
  }
}

.content {
  display: flex;

  .item {
    flex: 1;

    &:nth-last-child(1) {
      margin-left: 50px;
    }
  }
}
</style>
